import { Item } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import {
  A3innuvaContractTypeDocument,
  A3innuvaContractTypesFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SpanishContractData } from 'modules/contracts/hooks/useFetchSpanishContractData'
import {
  contractTypesToOptions,
  fullName,
} from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'

interface Props {
  form: Form
  spanishContractData: SpanishContractData
}

const ContractTypeField = ({ form, spanishContractData }: Props) => {
  const session = useCurrentSession()
  const contractTypeName = form.get('es_contract_type_payroll_integration_name').value
  const contractTypeCode = form.get('es_contract_type_payroll_integration_code').value
  const contractTypeId = form.get('es_contract_type_id').value
  const spainContractType = contractTypeId
    ? spanishContractData.contractTypes.find(({ id }) => id === Number(contractTypeId))
    : null

  const setCurrentContractType = (a3innuvaContractTypes: A3innuvaContractTypesFragment[]) => {
    if (spainContractType) {
      const currentContractType = a3innuvaContractTypes.find(
        ({ name }) => name === spainContractType?.name
      )

      if (currentContractType) {
        form.setValues({
          es_contract_type_payroll_integration_code: currentContractType.code,
          es_contract_type_payroll_integration_name: currentContractType.name,
        })
      }
    }
  }

  const isFormInitialized = () => {
    if (!form.has('es_contract_type_payroll_integration_name')) return false
    return form.get('es_contract_type_payroll_integration_name').value === spainContractType?.name
  }

  const { data: contractTypesData, loading } = useQuery(A3innuvaContractTypeDocument, {
    variables: {
      companyId: session.company.id,
      currentUserId: session.access.userId,
    },
  })
  const a3innuvaContractTypes = contractTypesData?.payrollIntegrationsA3innuva.contractTypes ?? []

  if (!loading && !isFormInitialized()) {
    setCurrentContractType(a3innuvaContractTypes)
  }

  const options = contractTypesToOptions(a3innuvaContractTypes)

  const labelNotFound = () => {
    return options.length
      ? i18n.t(
          'contract_versions.forms.contract_extra_information.a3innuva.contract_type_not_found'
        )
      : i18n.t('contract_versions.forms.contract_extra_information.a3innuva.label_not_found')
  }

  const onContractTypeChange = (option: Item) => {
    const selectedContractType = a3innuvaContractTypes.find(({ code }) => code === option.value)
    form.setValues({
      es_contract_type_payroll_integration_code: selectedContractType?.code,
      es_contract_type_payroll_integration_name: selectedContractType?.name,
      es_contract_type_id: undefined,
    })
  }

  return (
    <DropdownSearchBar
      name={fullName(contractTypeCode, contractTypeName)}
      label={i18n.t('contract_versions.forms.basic_information.es_contract_type')}
      onSelect={onContractTypeChange}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      loading={loading}
      popoverWidth="s400"
      ellipsis={false}
    />
  )
}

export default observer(ContractTypeField)
